import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ImageProvider } from './Component/Context/ImageContext';

// Height communication disabled - let iframe use natural scrolling
// All height communication code removed to prevent interference with iframe scrolling

// Render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ImageProvider>
      <App />
    </ImageProvider>
  </React.StrictMode>
);

// Performance measurement (optional)
reportWebVitals();